<section class="bg-dark text-light p-5 text-center text-sm-start">
  <div class="container">
    <div class="d-sm-flex align-items-center justify-content-between">
      <div>
        <h3 class="section-heading">
          Hello, <span class="text-warning">{{ fullName }}</span>
        </h3>
        <p class="sub-heading my-4">
          Welcome to Contact manager, here you can create the contacts, Groups
          and also manage them. Hope you'll enjoy our product
        </p>
        <a [routerLink]="'/create-contacts'"
          ><button class="btn btn-primary btn-lg btnStyles" type="button">
            Create a Contact
          </button></a
        >
      </div>
      <img
        src="assets/home-banner.png"
        class="img-fluid w-50 d-none d-sm-block"
        alt="main-bg"
      />
    </div>
  </div>
</section>

<section class="p-5 text-center text-sm-start mb-4">
  <h1 class="text-transform-uppercase text-center mt-4">Features</h1>
  <div class="mb-4 container" id="features">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
      <div class="row">
        <div
          class="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-8 cardCenter"
          (click)="triggerFeature('createGroup')"
        >
          <div class="card c-pointer cardStyles">
            <div class="inner-card text-center">
              <i class="fa fa-users fa-5x" aria-hidden="true"></i>
              <p class="mt-2">Create a Group</p>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-8 cardCenter"
          (click)="triggerFeature('createContact')"
        >
          <div class="card c-pointer cardStyles">
            <div class="inner-card text-center">
              <i class="fa fa-plus-square-o fa-5x" aria-hidden="true"></i>
              <p>Create a Contact</p>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-8 cardCenter"
          (click)="triggerFeature('view')"
        >
          <div class="card c-pointer cardStyles">
            <div class="inner-card text-center">
              <i class="fa fa-address-book-o fa-5x" aria-hidden="true"></i>
              <p class="mt-2">View All Contacts/Groups</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
